import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getSolicitanteById, getSolicitantes, toggleInteresadoSolicitante} from '../../services';
import {ISolicitante, ISolicitanteFilter, ISolicitanteRes, ISolicitanteState} from "../types/ISolicitante";
import {AppState} from "./rootReducer";

const initialState: ISolicitanteState = {
    status: "idle"
}

export const mostrarSolicitantes = createAsyncThunk(
    'mostrarSolicitantes', async (params:ISolicitanteFilter|undefined, thunkAPI ) => {
        const {solicitantes} = thunkAPI.getState() as AppState;
        let paramsFilter = params || solicitantes.filtered;

        const response = await getSolicitantes(paramsFilter)
        return {data: response.data as ISolicitanteRes, params: response.config.params}
    }
)
export const mostrarSolicitanteById = createAsyncThunk(
    'mostrarSolicitanteById', async (id:number,thunkAPI) => {
        // let byId = (thunkAPI.getState() as AppState)?.solicitantes?.list?.items?.find(c=>c.id === id);
        // if(byId){
        //     return {data: byId}
        // }

        const response = await getSolicitanteById(id);
        return {data: response.data as ISolicitante}
    }
)

export const marcarInteresadoSolicitante = createAsyncThunk(
    'marcarInteresadoSolicitante', async (id: number, thunkAPI) => {
        const response = await toggleInteresadoSolicitante(id);


        return {data: response.data};
    }
);



const slice = createSlice({
    name: 'mostrarSolicitantes',
    initialState,
    reducers: {},
    extraReducers: builder => {
        //--mostrarSolicitantes
        builder.addCase(mostrarSolicitantes.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarSolicitantes.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarSolicitantes.rejected, (state ) => {
            state.status = "idle";
        })

        //--mostrarSolicitanteById
        builder.addCase(mostrarSolicitanteById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarSolicitanteById.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload.data;
        })
        builder.addCase(mostrarSolicitanteById.rejected, (state ) => {
            state.status = "idle";
        })

        //--marcarInteresadoSolicitante
        builder.addCase(marcarInteresadoSolicitante.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(marcarInteresadoSolicitante.fulfilled, (state,action ) => {
            state.status = "idle";
            let data = action?.payload.data as ISolicitante;

            if (state.list) {
                state.list.items = state.list.items?.map(item => {
                    if (item.id === data.id) {
                        return { ...item, ...data};
                    }
                    return item;
                })
            }
        })
        builder.addCase(marcarInteresadoSolicitante.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
